export default __webpack_public_path__ + "static/media/profile.55a40eb4.png";